export const version = {
    appVersion: '3.1.1',
    buildDate: '2026-3-25 18:51:49'
}
